import { Injectable } from "@angular/core";
import { TransponderRequest, DefaultService } from "@psnb/psnb-api";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PSTransponderVendorsModelsService {
    constructor(private pSTransponderVendorsModelsService: DefaultService) {
        this.getTransponderDetails();
    }
    getTransponderDetails() {
        return this.pSTransponderVendorsModelsService.getTransponderDetails().pipe(map(result => result));
    }
    getTransponderVendorName() {
        return this.pSTransponderVendorsModelsService.getTransponderVendorName().pipe(map(result => result));
    }
    getTransponderModelName() {
        return this.pSTransponderVendorsModelsService.getTransponderModelName().pipe(map(result => result));
    }

    addTransponderDetails(model: TransponderRequest) {
        return this.pSTransponderVendorsModelsService.addTransponderDetails(model).pipe(map(result => result));
    }

    updateTransponderDetails(model: TransponderRequest) {
        return this.pSTransponderVendorsModelsService.updateTransponderDetails(model).pipe(map(result => result));
    }
    deleteTransponderDetail(id: number) {
        return this.pSTransponderVendorsModelsService.deleteTransponderDetail(id).pipe(map(result => result));
      }
}